<template>
  <div class="upd-tag-relation-editor">
    <div class="header">
      <div class="header-content">
        <div class="back-btn">
          <span>修改标注关联</span>
        </div>
      </div>
    </div>

    <div class="tag-relation-empty" v-if="groupingCase.length === 0">
      <span>该视图分组组暂无有效的关联关系</span>
    </div>

    <el-checkbox-group v-model="curPickFullIds" class="entities-content" v-else>
      <div class="entitie-pick-item" v-for="groupingCaseItem in groupingCase" :key="groupingCaseItem.fullId">
        <el-checkbox :label="groupingCaseItem.fullId">
          <span>{{ groupingCaseItem.fullContent }}</span>
        </el-checkbox>
      </div>
    </el-checkbox-group>

    <div class="bottom-btns">
      <el-button size="mini" @click="emit('close')">
        <span>取消</span>
      </el-button>
      <el-button
        size="mini"
        type="primary"
        :disabled="groupingCase.length === 0"
        :loading="confirmLoading"
        @click="confirmHandle"
      >
        <span>确认</span>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue';

import { intersection, intersectionBy, groupBy } from 'lodash';
import { Message } from 'element-ui';

const emit = defineEmits(['close', 'confirm']);
const props = defineProps({
  caseDetail: {
    type: Object,
    required: true
  },
  entityDetail: {
    type: Object,
    required: true
  },
  confirmLoading: {
    type: Boolean,
    default: false
  }
});

const groupingCase = computed(() => {
  const { fieldDetail } = props.entityDetail;

  return groupBy(props.caseDetail.groupingCase || [], 'groupRelationId')[fieldDetail.groupRelationId] || [];
});

const courseUnitGroups = inject('courseUnitGroups', () => []);

let defaultValArr = intersectionBy(groupingCase.value, props.entityDetail.relation, 'fullId');

if (defaultValArr.length === 0) {
  const groupingCaseEntityIdsArr = groupingCase.value.map(item => {
    return item.fullId.split('/');
  });

  props.entityDetail.relation.forEach(relationItem => {
    const parentEntityIds = relationItem.fullId.split('/');
    groupingCaseEntityIdsArr.forEach(entityIds => {
      if (intersection(entityIds, parentEntityIds).length > 0) {
        defaultValArr.push(entityIds.join('/'));
      }
    });
  });
  defaultValArr = [...new Set(defaultValArr)];
} else {
  defaultValArr = defaultValArr.map(o => o.fullId);
}

const curPickFullIds = ref(defaultValArr);

const confirmHandle = () => {
  if (curPickFullIds.value.length < 1) {
    Message.warning('请至少选择一个关联');
    return;
  }
  const { dataInfo, fieldDetail } = props.entityDetail;

  const curUnitGroup = courseUnitGroups.value.find(o => o.id === fieldDetail.groupRelationId);
  const { nerIds = '', labelIds = '' } = curUnitGroup || {};

  const parentLabelId = labelIds.length > 0 ? labelIds.slice(-1)[0] : nerIds.slice(-1)[0];

  if (!parentLabelId) {
    Message.warning('标注异常，当前标签对应分组已被删除，请修改标签的关联分组');
    return;
  }

  emit('confirm', {
    caseId: dataInfo.caseId,
    coursewareId: dataInfo.coursewareId,
    entityId: dataInfo.id,
    entityLabelId: fieldDetail.field_name,
    parentLabelId,
    fullIds: curPickFullIds.value
  });
};
</script>

<style lang="scss" scoped>
.upd-tag-relation-editor {
  .header {
    padding: 8px 14px 0px;
    border-bottom: 1px solid #e8ebef;
    margin-bottom: 5px;

    .header-content {
      position: relative;
      left: -4px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-bottom: 2px;

      .back-btn {
        box-sizing: border-box;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        padding: 0 5px 0 3px;
        color: #3d465a;
        font-size: 14px;
      }
    }
  }

  .tag-relation-empty {
    text-align: center;
    font-size: 12px;
    margin: 20px 0;
  }

  .entities-content {
    box-sizing: border-box;
    padding: 0 14px 5px;
    min-height: 100px;
    max-height: 260px;
    overflow-x: hidden;
    overflow-y: auto;

    .entitie-pick-item {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;

      ::v-deep .el-checkbox {
        width: 100%;
        display: flex;
        align-items: flex-start;

        .el-checkbox__input {
          position: relative;
          top: 3px;
        }

        .el-checkbox__label {
          flex: 1;
          width: 0;
          white-space: normal;
        }
      }

      .entitie-text {
        flex: 1;
        width: 0;
        font-size: 14px;
        line-height: 20px;
        word-break: break-all;
        margin-left: 5px;
      }
    }
  }

  .bottom-btns {
    text-align: right;
    border-top: 1px solid #e8ebef;
    padding: 11px;
  }
}
</style>
